// extracted by mini-css-extract-plugin
export default {"root":"IconEmailSent_root__rGryN"};